// const Url = "https://asu-ankete.onrender.com"
// const Url = "http://localhost:6200"
const Url = "https://seahorse-app-424ov.ondigitalocean.app"


export default Url;